// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/Section/SectionItem.less
// module id = 230
// module chunks = 2